import React from "react";

import { FormGroup } from "react-bootstrap";
import Label from "../Label/Label";

import InputError from "../InputError/InputError";
import CustomDateTime from "app/Components/DateTimeCustom/CustomDateTime";

function FormDateTimePicker(props) {
  const {
    name = null,
    format = "YYYY-MM-DD",
    value = "",
    placeholder = "Date",
    timeFormat = false,
    onChange,
    onChangeDate,
    inputProps,
    disabled = false,
    isValidDate = () => true,
    renderInput = "",
    closeOnSelect = false,
    readOnly = false,

    label,
    error,
    errorClassName,
  } = props;

  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <CustomDateTime
        name={name}
        format={format}
        value={value}
        placeholder={placeholder}
        timeFormat={timeFormat}
        onChange={onChange}
        onChangeDate={onChangeDate}
        inputProps={inputProps}
        disabled={disabled}
        isValidDate={isValidDate}
        renderInput={renderInput}
        closeOnSelect={closeOnSelect}
        readOnly={readOnly}
      />
      <InputError error={error} className={errorClassName} />
    </FormGroup>
  );
}

export default FormDateTimePicker;
